export const getNumberFromString = (txt = "") => {
  let noSpacesStr = txt.replace(/\s+/g, "");
  const arr = [...noSpacesStr];
  let ordernumber = "";
  for (let index = 0; index < arr.length; index++) {
    const element = arr[index];
    if (Number(element) >= 0) {
      ordernumber += element;
    }
  }
  return ordernumber;
};
